import { createAsyncThunk } from "@reduxjs/toolkit";
import { getComplianceCalendarApi } from "../../apis/complianceCalendarApis";
import { GetComplianceCalendarPayloadType } from "../../commonTypes/complianceCalendarTypes";

export const getComplianceCalendarAction = createAsyncThunk(
    "ComplianceCalendar/list",
    async (data: GetComplianceCalendarPayloadType) => {
    const response = await getComplianceCalendarApi(data);
    return response.data;
  });
